export default "/images/copy.svg?4c19a6dd8558a8e82f16d174837df176";